module.exports = __webpack_public_path__ + "assets/4a7e421791a2e1ee5fff3c0487e67d84.mp3";